import React, { useEffect, useState } from 'react';
import './BackofficeUsers.scss';
import { connect } from 'react-redux';
import {
  getBackofficeUsersActionRequest,
  filterBackofficeUsersAction,
  sortBackofficeUsersAction,
  updateQuickFilterAction
} from '../../store/backofficeUser/backofficeUserActions';
import MercurXBackofficeUserTable
 from '../../components/MercurXBackofficeUser/MercurXBackofficeUserTable';
import { Button, Col, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { backofficeUsersQuickFilterConstants } 
from './backofficeUsersConstants';


function BackofficeUsers({ ...props }) {
  const {
    getbackofficeUsersRequest,
    backofficeUsers,
    quickFilter,
    updateQuickFilter,
    sortBackofficeUsers,
    filterBackofficeUsers,
  } = props;

  const history = useHistory();
  const [filterInput, setFilterInput] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))?.user;
  useEffect(() => {
    getbackofficeUsersRequest();
    updateQuickFilter(backofficeUsersQuickFilterConstants.ALL)
  }, []);
  useEffect(() => {
    filterBackofficeUsers(filterInput);
    sortBackofficeUsers();
  }, [quickFilter]);

  useEffect(() => {
    filterBackofficeUsers(filterInput);
    sortBackofficeUsers();
  }, [filterInput])

  useEffect(() => {
    filterBackofficeUsers(filterInput);
    sortBackofficeUsers();
  }, [backofficeUsers]);

  function createNewUser() {
    history.push('/backoffice-users/create-new-user');
  }


  return (
    <>
      <div className="text-fs-head-md mb-4">Backoffice Users</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by full name or email..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <Row
        id="backofficeUsers-container"
        className="d-flex align-items-center justify-content-end mt-4"
      >
        <Col>
          <div className="backoffice-users-toolbar">
            <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
              <ToggleButton
                size={'sm'}
                variant={quickFilter === backofficeUsersQuickFilterConstants.ALL
                  ? 'primary' : 'light'}
                className={
                  quickFilter !== backofficeUsersQuickFilterConstants.ALL
                    ? 'text-t-body-color'
                    : ''
                }
                id="tbg-radio-1"
                value={backofficeUsersQuickFilterConstants.ALL}
                onClick={() => updateQuickFilter(backofficeUsersQuickFilterConstants.ALL)}
              >
                All
              </ToggleButton>
              <ToggleButton
                size={'sm'}
                variant={quickFilter === backofficeUsersQuickFilterConstants.TRUE
                  ? 'primary' : 'light'}
                className={
                  quickFilter !== backofficeUsersQuickFilterConstants.TRUE
                    ? 'text-t-body-color'
                    : ''
                }
                id="tbg-radio-2"
                value={backofficeUsersQuickFilterConstants.TRUE}
                onClick={() => updateQuickFilter(backofficeUsersQuickFilterConstants.TRUE)}
              >
                True
              </ToggleButton>
              <ToggleButton
                size={'sm'}
                variant={quickFilter === backofficeUsersQuickFilterConstants.FALSE
                  ? 'primary' : 'light'}
                className={
                  quickFilter !== backofficeUsersQuickFilterConstants.FALSE
                    ? 'text-t-body-color'
                    : ''
                }
                id="tbg-radio-3"
                value={backofficeUsersQuickFilterConstants.FALSE}
                onClick={() => updateQuickFilter(backofficeUsersQuickFilterConstants.FALSE)}
              >
                False
              </ToggleButton>
              <ToggleButton
                size={'sm'}
                variant={quickFilter === backofficeUsersQuickFilterConstants.WAIT
                  ? 'primary' : 'light'}
                className={
                  quickFilter !== backofficeUsersQuickFilterConstants.WAIT
                    ? 'text-t-body-color'
                    : ''
                }
                id="tbg-radio-4"
                value={backofficeUsersQuickFilterConstants.WAIT}
                onClick={() => updateQuickFilter(backofficeUsersQuickFilterConstants.WAIT)}
              >
                Wait
              </ToggleButton>
            </ToggleButtonGroup>
            {user.is_superuser && (
              <Button onClick={createNewUser} size={'sm'}>
                Create new user
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <div id="backofficeUsers-container">
        <MercurXBackofficeUserTable />
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    backofficeUsers: state.backofficeUserReducer.backofficeUsers,
    quickFilter: state.backofficeUserReducer.quickFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getbackofficeUsersRequest: (payload) => {
      dispatch(getBackofficeUsersActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    sortBackofficeUsers: (payload) => {
      dispatch(sortBackofficeUsersAction(payload));
    },
    filterBackofficeUsers: (payload) => {
      dispatch(filterBackofficeUsersAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackofficeUsers);
